import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertsContext, DistaDialog, DistaDialogHeader } from "@sista/dista-ui";
import { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSafeSistaAsync } from "@sista/library-stasi";
import { DialogContent, Typography } from "@mui/material";
import { useSpravaTextuClient } from "../../util/useSpravaTextuClient";
import { TextDTOForm } from "../../forms/TextDTOForm";
export const NewTextDialog = ({ canEdit, canTranslate, canView, tree, supportedLanguages, selectedNamespaces, onSuccess, onClose, }) => {
    const { t } = useTranslation("sprava-textu");
    const { showSuccess, showInfo } = useContext(AlertsContext);
    const spratex = useSpravaTextuClient();
    const [createTextCall, createTextState] = useSafeSistaAsync(spratex.createText);
    const [resetingFormOnSucessForNextText, setResetingFormOnSucessForNextText] = useState(false);
    const createAndCloseHandler = useCallback(async (data) => {
        const result = await createTextCall({
            ...data,
            namespace: data.namespace,
            key: data.key,
        });
        if (typeof result === "object" && result) {
            showSuccess(t("sprava-textu.admin.newText.textCreated", "Text vytvořen"));
            onSuccess?.();
        }
        onClose?.();
    }, [onClose, onSuccess, showSuccess, t, createTextCall]);
    const createAndNextHandler = useCallback(async (data) => {
        const result = await createTextCall({
            ...data,
            namespace: data.namespace,
            key: data.key,
        });
        if (typeof result === "object" && result) {
            showSuccess(t("sprava-textu.admin.newText.textCreated", "Text vytvořen"));
            onSuccess?.();
        }
        setResetingFormOnSucessForNextText(true);
    }, [
        setResetingFormOnSucessForNextText,
        onSuccess,
        showSuccess,
        t,
        createTextCall,
    ]);
    return (_jsxs(DistaDialog, { open: true, onClose: onClose, children: [_jsx(DistaDialogHeader, { title: t("sprava-textu.admin.newText.title", "Vložit nový text"), onClose: onClose }), _jsxs(DialogContent, { children: [_jsx(Typography, { variant: "body1", sx: { mb: 2 }, children: t("sprava-textu.admin.newText.description", "Zadejte prosím údaje o novém textu. Text bude přidán do vybraného jmenného prostoru.") }), _jsx(TextDTOForm, { canEdit: canEdit ?? true, canTranslate: canTranslate ?? true, canView: canView ?? true, tree: tree, supportedLanguages: supportedLanguages, resetingFormOnSucessForNextText: resetingFormOnSucessForNextText, onReset: () => {
                            return setResetingFormOnSucessForNextText(false);
                        }, selectedNamespaces: selectedNamespaces, onSuccess: (data) => createAndCloseHandler(data), onMoreTexts: (data) => createAndNextHandler(data) })] })] }));
};
